import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PushLiveTimeValidityService {
  isPushLiveTimeValid$ = new BehaviorSubject<boolean>(false);
}
